// extracted by mini-css-extract-plugin
export default {"CenteredLoader":"WithLoadingData_CenteredLoader__CCvMa"};